import React from "react";
import { useDropzone } from "react-dropzone";

export default function FileDropzone({ onDrop, file }) {
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop: (acceptedFiles) => {
      // Đảm bảo chỉ file hợp lệ được truyền lên
      if (acceptedFiles && acceptedFiles.length > 0) {
        const selectedFile = acceptedFiles[0];
        // Kiểm tra file có phải là File object thực sự không
        if (selectedFile instanceof File) {
          onDrop(acceptedFiles);
        } else {
          console.error("Invalid file object:", selectedFile);
          alert("File không hợp lệ, vui lòng thử lại");
        }
      }
    },
    multiple: false,
    accept: {
      // Chấp nhận tất cả các loại file phổ biến
      "application/pdf": [".pdf"],
      "image/jpeg": [".jpeg", ".jpg"],
      "image/png": [".png"],
      "application/msword": [".doc"],
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
        [".docx"],
      "application/vnd.ms-excel": [".xls"],
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [
        ".xlsx",
      ],
      // Thêm các định dạng khác nếu cần
      "text/plain": [".txt"],
      "application/zip": [".zip"],
    },
  });

  return (
    <div
      {...getRootProps()}
      style={{
        border: "2px dashed #1976d2",
        borderRadius: 8,
        padding: 16,
        textAlign: "center",
        background: isDragActive ? "#e3f2fd" : "#fafafa",
        cursor: "pointer",
        // minHeight: 60,
      }}
    >
      <input {...getInputProps()} />
      {file ? (
        <span>{file.name}</span>
      ) : (
        <span>Kéo thả hoặc bấm để chọn file</span>
      )}
    </div>
  );
}
